export default __webpack_public_path__ + "static/media/hero_eigth.74391fbb.jpg";